<template>
  <div class="deliveryPointsNumberForm">
    <table class="table productForm__serviceTable">
      <tbody class="productForm__rows">
        <tr>
          <product-row-form
            :product="getDeliveryAddressProduct"
            :delivery_id="0"
            @updateProduct="updateProduct"
          />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ProductRowForm from '@/components/Product/ProductRowForm.vue';

export default {
  name: 'DeliveryPointsNumberForm',
  components: {
    ProductRowForm,
  },
  methods: {
    updateProduct(product) {
      this.$store.dispatch('updateProduct', product);
    },
  },
  computed: {
    getDeliveryAddressProduct() {
      return this.$store.getters.getDeliveryAddressProduct || {};
    },
  },
};
</script>

<style lang="scss" scoped>
.deliveryPointsNumberForm ::v-deep .table {
  td:first-of-type, td:not(:first-of-type) {
    &::before {
      content: unset;
    }
  }
  td.productForm__itemName {
    padding-left: 0;
    padding-block: 0;
  }
  td.productForm__itemValue {
    padding-right: 0;
    padding-block: 0;
    display: table-cell;
  }
}
</style>
